import React, { useState } from 'react';
import { InputField, Modal, Text } from '@getpingback/realeza';
import { useDispatch } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { TrashCanIcon, PlusIcon } from '@stash-ui/regular-icons';
import { Button, IconButton, CircularProgress } from '@material-ui/core';
import { showAlert } from '../../../store/ducks/alert';
import { createCheckout, createCouponCourtesy } from '../../../services/saasplans';

const CheckoutModal = ({ isOpen, onClose, selectedItems, onClearSelection, onRemoveItem }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [couponInputValue, setCouponInputValue] = useState('');
  const [saasPlansWithCoupons, setSaasPlansWithCoupons] = useState([]);
  const [url, setUrl] = useState('');

  const handleClearButton = () => {
    onClearSelection();
    onClose();
    setCoupons([]);
    setSaasPlansWithCoupons([]);
  };

  const getCouponCourtesy = async planId => {
    try {
      const { data } = await createCouponCourtesy(planId);
      setSaasPlansWithCoupons([...saasPlansWithCoupons, { planId, coupon: data.code }]);
      setCoupons([...coupons, data.code]);
    } catch (error) {
      console.log(error);
    }
  };

  const onRemoveCoupon = coupon => {
    const newCoupons = coupons.filter(c => c !== coupon);
    const newSaasPlansWithCoupons = saasPlansWithCoupons.filter(c => c.coupon !== coupon);
    setCoupons(newCoupons);
    setSaasPlansWithCoupons(newSaasPlansWithCoupons);
  };

  const onAddCoupon = () => {
    if (couponInputValue) {
      const formattedValue = couponInputValue.toUpperCase();
      setCoupons([...coupons, formattedValue]);
      setCouponInputValue('');
    }
  };

  const onCreateCheckout = async () => {
    try {
      setIsLoading(true);
      const plansIds = selectedItems.map(item => item.id);

      const { data } = await createCheckout(JSON.stringify(plansIds), JSON.stringify(coupons));
      setUrl(data.url);

      setIsLoading(false);
    } catch (error) {
      console.log('error', error);
      dispatch(showAlert('error', 'Failed to create checkout'));
      setIsLoading(false);
    }
  };

  const handleCopyUrl = () => {
    try {
      navigator.clipboard.writeText(url);
      dispatch(showAlert('success', 'URL copied to clipboard'));
    } catch (error) {
      dispatch(showAlert('error', 'Failed to copy URL to clipboard'));
    }
  };

  const handleClose = () => {
    if (url) {
      setUrl('');
      onClearSelection();
      onClose();
      setCoupons([]);
      setSaasPlansWithCoupons([]);
    } else {
      onClose();
      setCoupons([]);
      setSaasPlansWithCoupons([]);
    }
  };

  const renderCoupons = plan => {
    const planCoupon = saasPlansWithCoupons.find(coupon => coupon.planId === plan.id);

    return planCoupon ? (
      <div className="saasPlans__modal__content__table__coupon">
        <Text size={14} color="white">
          {planCoupon.coupon}
        </Text>
        <button onClick={() => onRemoveCoupon(planCoupon.coupon)}>
          <CloseIcon />
        </button>
      </div>
    ) : (
      <button className="saasPlans__modal__content__table__add-coupon" onClick={() => getCouponCourtesy(plan.id)}>
        Add courtesy
      </button>
    );
  };

  return (
    <Modal onClose={handleClose} isOpen={isOpen} className="saasPlans__modal">
      <div className="saasPlans__modal__top">
        <h2>Create Checkout</h2>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <div className="saasPlans__modal__content">
        <div className="saasPlans__modal__content__table">
          <table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Value</th>
                <th>Type</th>
                <th>Tier</th>
                <th>periodOfMonths</th>
                <th>Coupons</th>
                <th> </th>
              </tr>
            </thead>

            <tbody>
              {selectedItems.map((item, index) => (
                <tr key={index}>
                  <td>{item.id ? item.id : '-'}</td>
                  <td>{item.name ? item.name : '-'}</td>
                  <td>{item.value ? item.value : '-'}</td>
                  <td>{item.type ? item.type : '-'}</td>
                  <td>{item.tier ? item.tier : '-'}</td>
                  <td>{item.periodOfMonths}</td>
                  <td>{renderCoupons(item)}</td>
                  <td>
                    <IconButton onClick={() => onRemoveItem(item)}>
                      <TrashCanIcon />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="saasPlans__modal__content__table__coupons">
            <Text size={18} color="white" weight="bold">
              Coupons
            </Text>
            <div className="saasPlans__modal__content__table__coupons__list">
              <div className="saasPlans__modal__content__table__coupons__list__input">
                <InputField onChange={e => setCouponInputValue(e.target.value)} value={couponInputValue} />
                <button className="saasPlans__modal__content__table__add-coupon" onClick={() => onAddCoupon()}>
                  <PlusIcon />
                </button>
              </div>
              <div className="saasPlans__modal__content__table__coupons__list__coupons">
                {coupons.map((coupon, index) => (
                  <div key={index} className="saasPlans__modal__content__table__coupon">
                    <Text size={14} color="white">
                      {coupon}
                    </Text>
                    <button onClick={() => onRemoveCoupon(coupon)}>
                      <CloseIcon />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {url && (
            <div className="saasPlans__modal__content__table__copy">
              <input type="text" value={url} readOnly />
              <Button variant="outlined" onClick={() => handleCopyUrl()}>
                Copy
              </Button>
            </div>
          )}

          <div className="saasPlans__modal__content__table__footer">
            <Button onClick={handleClearButton} variant="outlined">
              Clear selection
            </Button>
            <Button onClick={() => onCreateCheckout()} variant="contained" className="saasPlans__modal__content__table__footer--btn">
              {isLoading ? <CircularProgress size={24} /> : null}
              Create Checkout
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CheckoutModal;
